


























































































































































import Vue, { PropType } from "vue";

export interface OffersStudentDiscountsPlansProps {
  action: string;
  lang: any;
  plans: any;
  gradeNames: any;
  countries: any;
  currencies: any;
  prices: any;
  defaultData: any;
  extendParams: any;
  prevUrl: string;
}

// 海外学割は 2 デバイスのみ
const AVAILABLE_DEVICE_TYPE = "double";
// 海外学割は年額のみ
const AVAILABLE_TERM_TYPE = "year";

// 選択可能なプランのすべてのグレードについて、それぞれ指定通貨での価格を取得する
const getPrices = (
  currencyCode: string,
  { plans, prices, gradeNames }: OffersStudentDiscountsPlansProps
) =>
  Object.entries(gradeNames).reduce((acc, grade: any) => {
    const gradeCode: string = grade[0];
    const gradeText: string = grade[1];
    const planCode: string =
      plans[AVAILABLE_DEVICE_TYPE][gradeCode][AVAILABLE_TERM_TYPE];
    const price: number = prices[planCode][currencyCode];
    return Object.assign(acc, { [gradeText]: price });
  }, {});

export default Vue.extend({
  name: "vc-student-discounts-plans",

  data() {
    return {
      device_type: AVAILABLE_DEVICE_TYPE,
      grade_type: this.defaultData.grade_type,
      term_type: AVAILABLE_TERM_TYPE,
      currency_code: this.defaultData.currency_code,
      country_code: this.defaultData.country_code,
      currentPrices: getPrices(this.defaultData.currency_code, this)
    };
  },

  props: {
    action: {
      type: String as PropType<OffersStudentDiscountsPlansProps["action"]>,
      default: ""
    },
    lang: {
      type: Object as PropType<OffersStudentDiscountsPlansProps["lang"]>,
      default: () => {}
    },
    plans: {
      type: Object as PropType<OffersStudentDiscountsPlansProps["plans"]>,
      default: () => {}
    },
    gradeNames: {
      type: Object as PropType<OffersStudentDiscountsPlansProps["gradeNames"]>,
      default: () => {}
    },
    countries: {
      type: Array as PropType<OffersStudentDiscountsPlansProps["countries"]>,
      default: () => []
    },
    currencies: {
      type: Array as PropType<OffersStudentDiscountsPlansProps["currencies"]>,
      default: () => {}
    },
    prices: {
      type: Object as PropType<OffersStudentDiscountsPlansProps["prices"]>,
      default: () => {}
    },
    defaultData: {
      type: Object as PropType<OffersStudentDiscountsPlansProps["defaultData"]>,
      default: () => {}
    },
    extendParams: {
      type: Object as PropType<
        OffersStudentDiscountsPlansProps["extendParams"]
      >,
      default: () => {}
    },
    prevUrl: {
      type: String as PropType<OffersStudentDiscountsPlansProps["prevUrl"]>,
      default: ""
    }
  },

  computed: {
    firstCountryList(): Object[] {
      return this.countries.filter((c: any) => c.display_list_priority === 1);
    },
    secondCountryList(): Object[] {
      return this.countries.filter((c: any) => c.display_list_priority === 2);
    },
    gradeDescriptions(): Object {
      return Object.entries(this.lang.grade_descriptions).reduce(
        (acc, desc: any) => {
          const key: string = desc[0];
          const str: string = desc[1];
          return Object.assign(acc, { [key]: str.replace(":br", "<br />") });
        },
        {}
      );
    }
  },

  methods: {
    onChangeCurrency() {
      this.currentPrices = getPrices(this.currency_code, this);
    },
    onSubmit() {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", "plan_code");
      input.setAttribute("value", this.getSelectedPlanCode());
      const form = this.$refs.formOffers as HTMLFormElement;
      form.appendChild(input);
      form.submit();
    },
    getSelectedPlanCode(): string {
      return this.plans[this.device_type][this.grade_type][this.term_type];
    }
  },

  watch: {}
});
